import createApp from '@shopify/app-bridge';

const useShopify = (host) => {
  const config = {
    apiKey: process.env.MIX_SHOPIFY_API_KEY,
    host: host || new URLSearchParams(location.search).get("host"),
    forceRedirect: true
  };

  const baseUrl = process.env.MIX_SHOPIFY_APP_URL;

  const app = createApp(config);

  return {
    baseUrl,
    app,
  };
};

export default useShopify;